<script>
    import { link } from "svelte-routing";

    export let href = "/";
    export let icon = "🤖";
    export let text = "Menüpunkt";
</script>

<li>
    <a use:link href={href}><i>{icon}</i><span>{text}</span></a>
</li>

<style>
    li {
        margin: 0;
        padding: 0;
    }

    a {
        display: block;
        padding: 0.5rem;
        padding-right: 1rem;
        color: #666;
        display: flex;
    }

    a:hover {
        text-decoration: none;
        background-color: #F0F0F0;
    }

    i {
        font-style: normal;
        margin-right: 0.5rem;
    }
</style>